//================================================================================

//require( '../style/stylus/main.styl' );
require( './eusw.umd.js' );
//var os = require('os');
import * as IEUSignCP from './eusw.umd';

//================================================================================

var current_time = (new Date()).getTime();
let g_caAddress = "acskidd.gov.ua";
let g_caPort = "80";
let g_isNeedReadNewKey = false;
let g_cas = null;
var G_URL_CAS = "/Data/CAs.json?time=" + current_time;
var G_URL_CAS_CERTIFICATES = "/Data/CACertificates.p7b?time=" + current_time;
var URL_EUSignWebInstall = "";
var confirmModal = '';
var version = "1.3.74"

//================================================================================

var eu_wait = function(first) { 
	return new (function() { 
		var self = this;
		var callback = function() {
			var args;
			if(self.deferred.length) {
				args = [].slice.call(arguments); 
				args.unshift(callback); 
				self.deferred[0].apply(self, args); 
				self.deferred.shift(); 
			}
		}
		this.deferred = [];
		this.eu_wait = function(run) {
			this.deferred.push(run); 
			return self; 
		}
		first(callback);
	});
};

//--------------------------------------------------------------------------------

function log(msg) {
	console.log(msg);
}
//--------------------------------------------------------------------------------

function saveEUSignWebInstall(data) {
    var foundPos = URL_EUSignWebInstall.lastIndexOf('/');
    if (foundPos > -1) {
        foundPos++;
        var filename = URL_EUSignWebInstall.substr(foundPos);
        saveFile(filename, data);
    }
}
//================================================================================

function loadCryptoLibrary(onSuccess, onError) {
	log("Load library...");

	var loader = new IEUSignCP.EndUserLibraryLoader(
		IEUSignCP.EndUserLibraryLoader.LIBRARY_TYPE_DEFAULT, "euSign");

	loader.onload = function(library) {
		let ltype = loader.getLibraryType();
                log("Libary loaded: "+ltype);               
                g_euSign = library;
                onSuccess();                
	};
	loader.onerror = function(msg, errorCode, libraryOrNull){
            log("Libary load failed. Error - " + msg);
            if (URL_EUSignWebInstall === "") {
                onError(msg);
            } else {                
                dssuConfirm('Завантаження агенту підпису', 'Після встановлення агенту підпису - оновити веб-сторінку. Завантажити агент підпису?', function(e) {
                    eu_wait(function(runNext) {        
                        LoadDataFromServer(URL_EUSignWebInstall, 
                            runNext, onError, true);
                    }).eu_wait(function (runNext, EUSignWebInstall) {
                        saveEUSignWebInstall(EUSignWebInstall);
                    }); 
                }, function(e) {
                    onError();
                });                
            }
	};

	loader.load();
}

//--------------------------------------------------------------------------------

function initializeCryptoLibrary(onSuccess, onError) {
	log("Initialize library...");

	var _onError = function(e) {
		log("Initialize library failed. Error - " + e);

		onError(e);
	};

	eu_wait(function(runNext) {
		g_euSign.SetUIMode(false, runNext, _onError);
	}).eu_wait(function(runNext) {
		g_euSign.Initialize(runNext, _onError);
	}).eu_wait(function(runNext) {
		g_euSign.SetUIMode(false, runNext, _onError);
	}).eu_wait(function(runNext) {
		log("Library initialized");                
		onSuccess();
	});
}

//--------------------------------------------------------------------------------

function setSettings(onSuccess, onError) {
	log("Set library settings...");

	var _onError = function(e) {
		log("Initialize library failed. Error - " + e);

		onError(e);
	};

	eu_wait(function(runNext) {
		g_euSign.SetRuntimeParameter(
			g_euSign.EU_SAVE_SETTINGS_PARAMETER,
			g_euSign.EU_SETTINGS_ID_PROXY,
			runNext, onError);
	}).eu_wait(function(runNext) {
		var settings = g_euSign.CreateFileStoreSettings();
		settings.SetPath("");
		settings.SetAutoRefresh(true);
		settings.SetSaveLoadedCerts(true);
		settings.SetExpireTime(3600);
		settings.SetCheckCRLs(true);
		settings.SetOwnCRLsOnly(true);
		settings.SetAutoDownloadCRLs(false);
		settings.SetFullAndDeltaCRLs(false);

		g_euSign.SetFileStoreSettings(
			settings, runNext, _onError);
	}).eu_wait(function(runNext) {
	g_euSign.GetProxySettings(
		function(proxy) {
			runNext();
		},
		function(e) {
			g_euSign.GetSystemProxySettings(
				function(proxy) {
					if (proxy.GetUseProxy() && proxy.GetPort() == '') {
						if (proxy.GetAddress().startsWith("https://")) {
							proxy.SetPort("443");
						} else {
							proxy.SetPort("80");
						}
					}
					g_euSign.SetProxySettings(proxy,
						runNext, _onError);
				},
				function(e) {
					var proxy = g_euSign.CreateProxySettings();
					g_euSign.SetProxySettings(proxy,
						runNext, _onError);
				});
		});
	}).eu_wait(function(runNext) {
		var settings = g_euSign.CreateTSPSettings();
//		settings.SetGetStamps(true);
//		settings.SetAddress(g_caAddress);
//		settings.SetPort(g_caPort);

		g_euSign.SetTSPSettings(
			settings, runNext, _onError);
	}).eu_wait(function(runNext) {
		var settings = g_euSign.CreateOCSPSettings();
		settings.SetUseOCSP(true);
//		settings.SetAddress(g_caAddress);
//		settings.SetPort(g_caPort);
		settings.SetBeforeStore(false);

		g_euSign.SetOCSPSettings(
			settings, runNext, _onError);
	}).eu_wait(function(runNext) {
		var settings = g_euSign.CreateLDAPSettings();

		g_euSign.SetLDAPSettings(
			settings, runNext, _onError);
	}).eu_wait(function(runNext) {
		var settings = g_euSign.CreateCMPSettings();
//		settings.SetUseCMP(true);
//		settings.SetAddress(g_caAddress);
//		settings.SetPort(g_caPort);
//		settings.SetCommonName("");

		g_euSign.SetCMPSettings(
			settings, runNext, _onError);
	}).eu_wait(function(runNext) {
		var settings = g_euSign.CreateModeSettings();
		settings.SetOfflineMode(false);
		g_euSign.SetModeSettings(settings,
			runNext, _onError);
	}).eu_wait(function(runNext){
            LoadDataFromServer(G_URL_CAS, 
		runNext, onError, false);
            console.log("G_URL_CAS");
        }).eu_wait(function(runNext, response){
            try {
                    g_cas = JSON.parse(response.replace(/\\'/g, "'"));
                    TokenValues.g_cas = g_cas;
                    g_euSign.GetOCSPAccessInfoModeSettings(runNext, _onError); 
                    console.log('LoadCAs');                    
            } catch (e) {
                    onError(e);
            }            
        }).eu_wait(function(runNext, settingsmode){
            var cnt = 0;
            var current = 0;
            var _onSuccess = function(e) {
                current++;
                if (current === cnt) {
                    log("Settings set");
                    TokenValues.g_caAddress = g_caAddress;
                    TokenValues.g_caPort = g_caPort;
                    onSuccess();
                }
            };
            settingsmode.SetEnabled(true);
            console.log("g_cas", g_cas);
        
            var settings = g_euSign.CreateOCSPAccessInfoSettings(); 
            console.log("SetOCSPAccessInfoSettings", settings);
            
            for (var i = 0; i < g_cas.length; i++) {		
		for (var j = 0; j < g_cas[i].issuerCNs.length; j++) {
                    cnt++;
		}
            }            
            for (var i = 0; i < g_cas.length; i++) {
		settings.SetAddress(g_cas[i].ocspAccessPointAddress);
		settings.SetPort(g_cas[i].ocspAccessPointPort);
                console.log("SetOCSPAccessInfoSettings", settings);
		for (var j = 0; j < g_cas[i].issuerCNs.length; j++) {
			settings.SetIssuerCN(g_cas[i].issuerCNs[j]);
			g_euSign.SetOCSPAccessInfoSettings(settings, _onSuccess, _onError); 
		}
            }            
        });
}


//==============================================================================


function TLoadCAs(onSuccess, onError) {
	var _onSuccess = function(response) {
		try {
			var cas = JSON.parse(response.replace(/\\'/g, "'"));

			g_cas = cas;	
                        console.log('LoadCAs');
			onSuccess();
		} catch (e) {
			onError(e);
		}
	};
        LoadDataFromServer(G_URL_CAS, 
		_onSuccess, onError, false);	
};
//------------------------------------------------------------------------------

function TSetOCSPAccessInfoSettings() {
//	var settings = g_euSign.CreateOCSPAccessInfoModeSettings();CreateOCSPAccessInfoSettings
//	settings.SetEnabled(true);
        
        var settings = g_euSign.GetOCSPAccessInfoModeSettings;
	g_euSign.SetOCSPAccessInfoModeSettings(settings);

	settings = g_euSign.CreateOCSPAccessInfoSettings(); 
	for (var i = 0; i < g_cas.length; i++) {
		settings.SetAddress(g_cas[i].ocspAccessPointAddress);
		settings.SetPort(g_cas[i].ocspAccessPointPort);

		for (var j = 0; j < g_cas[i].issuerCNs.length; j++) {
			settings.SetIssuerCN(g_cas[i].issuerCNs[j]);
			g_euSign.SetOCSPAccessInfoSettings(settings); 
		}
	}
};
//--------------------------------------------------------------------------------

function getKMTypes(onSuccess, onError) {
	log("Get key media types");

	var kmTypes = new Array();

	var _getKeyMediaType = function (index) {
		g_euSign.EnumKeyMediaTypes(index,
			function (type) {
				if (type == null || type == '') {
					log("Get key media types. Types - " + kmTypes);

					onSuccess(kmTypes);
					return;
				}

				kmTypes.push(type);
				_getKeyMediaType(index + 1);
			},
			function (e) {
				log("Get key media types failed. Error - " + e);

				onError(e);
			});
	}

	_getKeyMediaType(0);
}

//--------------------------------------------------------------------------------

function getKMDevices(typeIndex, onSuccess, onError) {
	log("Get key media devices");

	var kmDevices = new Array();

	var _getKeyMediaDevice = function (typeIndex, deviceIndex) {
		g_euSign.EnumKeyMediaDevices(typeIndex, deviceIndex,
			function (device) {
				if (device == null || device == '') {
					log("Get key media devices. Devices - " + kmDevices);
					
					onSuccess(kmDevices);
					return;
				}

				kmDevices.push(device);
				_getKeyMediaDevice(typeIndex, deviceIndex + 1);
			},
			function (e) {
				log("Get key media devices failed. Error - " + e);
				
				onError(e);
			});
	}

	_getKeyMediaDevice(typeIndex, 0);
}

//================================================================================

function updateKMTypes(onSuccess, onError) {
	log("Update key media types...");

	var _onError = function(e) {
		log("Update key media types failed. Error - " + e);

		onError(e);
	};

	eu_wait(function(runNext) {
		getKMTypes(runNext, _onError);
	}).eu_wait(function(runNext, kmTypes) {
		$('.km-types').empty();
		
		if (kmTypes.length != 0) {
			$.each(kmTypes, function (index, value) {
				$('.km-types').append(
					$('<option/>', { 
						value: value,
						text : value 
					}));
			});
			
			$('.km-types').val(kmTypes[0]);
		}

		getKMDevices(0, runNext, _onError);
	}).eu_wait(function(runNext, kmDevices) {
		$('.km-devices').empty();

		if (kmDevices.length != 0) {
			$.each(kmDevices, function (index, value) {
				$('.km-devices').append(
					$('<option/>', { 
						value: value,
						text : value 
					}));
			});

			$('.km-devices').val(kmDevices[0]);
		}

		log("Key media types updated");

		onSuccess();
	});
}

//--------------------------------------------------------------------------------

function updateKMDevices() {
	log("Update key media devices...");

	var _onError = function(e) {
		log("Update key media devices failed. Error - " + e);

		var error = "Виникла помилка при оновленні списку носіїв ключової інформації" +
			(e ? (". " + e) : "");

		alert(error);
	};

	eu_wait(function(runNext) {
		getKMDevices($('.km-types').prop('selectedIndex'), 
			runNext, _onError);
	}).eu_wait(function(runNext, kmDevices) {
		$('.km-devices').empty();

		if (kmDevices.length != 0) {
			$.each(kmDevices, function (index, value) {
				$('.km-devices').append(
					$('<option/>', { 
						value: value,
						text : value 
					}));
			});

			$('.km-devices').val(kmDevices[0]);
		}

		log("Key media devices updated");
	});
}

//--------------------------------------------------------------------------------

function onLoad() {
	var _onError = function(e) {
		var error = "Виникла помилка при завантаженні бібліотеки" + 
			(e ? (". " + e) : "");

		alert(error);                
	};
	
	eu_wait(function(runNext) {
		loadCryptoLibrary(runNext, _onError);
	}).eu_wait(function(runNext) {
		initializeCryptoLibrary(runNext, _onError);
	}).eu_wait(function(runNext) {
		setSettings(runNext, _onError);
	}).eu_wait(function(runNext) {
		updateKMTypes(runNext, _onError);
	}).eu_wait(function(runNext) {
		$(".km-types").prop("disabled", false);
		$(".km-devices").prop("disabled", false);
		$("#AccountantPKeyPassword").prop("disabled", false);                
                console.log('G_URL_CAS_CERTIFICATES', G_URL_CAS_CERTIFICATES);
                LoadDataFromServer(G_URL_CAS_CERTIFICATES, 
		runNext, _onError, true);
        }).eu_wait(function (runNext, certificates) {   
            g_euSign.SaveCertificates(certificates, runNext, _onError);
                        console.log('LoadCAsCertificates', certificates);
        }).eu_wait(function (runNext) {   
            console.log("URL_CERTIFICATE_SERVER");
            LoadDataFromServer(URL_CERTIFICATE_SERVER, 
		runNext, _onError, true);
        }).eu_wait(function (runNext, certificate) { 
            console.log("SaveCertificate", certificate);
            g_euSign.SaveCertificate(certificate, runNext, _onError);
            isLoadToken = true;
        }).eu_wait(function (runNext) { 
            console.log("GetHostInfo");
            g_euSign.GetHostInfo(runNext, _onError);            
        }).eu_wait(function (runNext, info) {
            let info_json = JSON.parse(info);
            console.log("info", info_json);
            g_euSign.GetVersion(runNext, _onError);            
        }).eu_wait(function (runNext, currentVersion) {            
            console.log("version", currentVersion);
            // if (version !== currentVersion) {
            //     dssuConfirm('Завантаження оновленного агенту підпису', 'Встановлена версія агенту підпису застаріла. Завантажити новий агент підпису? (Після встановлення оновленого агенту підпису треба оновити веб-сторінку.)', function(e) {
            //         eu_wait(function(runNext) {
            //             LoadDataFromServer(URL_EUSignWebInstall,
            //                 runNext, _onError, true);
            //         }).eu_wait(function (runNext, EUSignWebInstall) {
            //             saveEUSignWebInstall(EUSignWebInstall);
            //         });
            //     }, function(e) {
            //         _onError();
            //     });
            // }
        });
}


//================================================================================

$(document).ready(function (e) {
    var parser = new UAParser();
    var result = parser.getResult();
    if ((!!result.device.vendor) && (result.device.vendor === 'Apple')) {
        URL_EUSignWebInstall = URL_EUSignWebInstallApple;
    } else if (result.os.name === 'Windows') {
        URL_EUSignWebInstall = URL_EUSignWebInstallWin;
    } else if (result.os.name === 'Ubuntu') {
        confirmModal = 'select';         
        var str = new String($('#confirm-text-select-arch').val());        
        URL_EUSignWebInstall = window[str];         
    }; 
    $('#confirm-text-select-arch').change(function (e) {        
        var str = new String($(e.target).val());        
        URL_EUSignWebInstall = window[str];         
    });
    $(window).on('reloadToken', function (e) {
        console.log('reloadToken');
        onLoad();
        $('.km-types').on('change', function(e) {
                e.preventDefault();
                updateKMDevices();

                g_isNeedReadNewKey = true;
        });
    
        $('.km-devices').on('change', function(e) {
                e.preventDefault();

                g_isNeedReadNewKey = true;
        });
    });
});
//================================================================================
